<template>
<div class="chapter">
<div class="inner_page">
<p class="ctfm"><a id="page_vii"><b>CONTENTS</b></a></p><a id="page_vii">
</a><p class="toc1"><a id="page_vii"></a><a href="#/xhtml/08_Acknowledgement#ack" id="ack"><i>Acknowledgments</i></a></p>
<p class="toc1"><a href="#/xhtml/09_Introduction#int" id="int">Introduction</a></p>
<p class="tocf"><a href="#/xhtml/10_Part01#pt1" id="pt1"><i>Part I. Redrawing the Boundaries</i></a></p>
<p class="toc2"><a href="#/xhtml/11_Chapter01#ch1" id="ch1">1  Accommodation and Exclusion: Writing Community in the 1559 <i>Book of Common Prayer</i></a></p>
<p class="tocf"><span href="#/xhtml/12_Part02#pt2" id="pt2" title="Link target outside of Sample"><i>Part II. Early Responses—Mourning and Exclusion</i></span></p>
<p class="toc2"><span href="#/xhtml/13_Chapter02#ch2" id="ch2" title="Link target outside of Sample">2  Failing Consolation in Edmund Spenser’s Elegies</span></p>
<p class="toc2"><span href="#/xhtml/14_Chapter03#ch3" id="ch3" title="Link target outside of Sample">3  Robert Southwell’s Mission of Mourning</span></p>
<p class="tocf"><span href="#/xhtml/15_Part03#pt3" id="pt3" title="Link target outside of Sample"><i>Part III. Later Responses—Accommodating the Mystical Body</i></span></p>
<p class="toc2"><span href="#/xhtml/16_Chapter04#ch4" id="ch4" title="Link target outside of Sample">4  Reading Communion: Mystical Audience in John Donne’s Lyric Poetry</span></p>
<p class="toc2"><span href="#/xhtml/17_Chapter05#ch5" id="ch5" title="Link target outside of Sample">5  In or Out? Lingering on the Threshold of George Herbert’s <i>The Temple</i></span></p>
<p class="toc2"><span href="#/xhtml/18_Chapter06#ch6" id="ch6" title="Link target outside of Sample">6  Incarnating Mystical Community in Crashaw’s English Lyrics</span></p>
<p class="tocf"><span href="#/xhtml/19_Notes#notes" id="notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc1"><span href="#/xhtml/20_Bibliography#bib" id="bib" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc1"><span href="#/xhtml/21_Index01#idx" id="idx" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?aa61a5c2